<div class="app-alert" [ngClass]="'app-alert--' + alertType" *ngIf="visible">
  <div class="app-alert__title--wrapper">
    <span class="title__icon title__icon--left" [ngClass]="'title__icon--left-' + alertType"
      aria-hidden="true">{{AlertTypeToIcon[alertType]}}</span>
    <span class="app-alert__title" [ngClass]="titleClass" role="heading" [attr.aria-level]="headingLvl">{{title |
      translate}}</span>
    <span class="title__icon title__icon--right" *ngIf="showCloseBtn" aria-hidden="true"
      (click)="onClose()">close</span>
  </div>
  <div class="app-alert__content--wrapper">
    <ng-content></ng-content>
  </div>
</div>
